export const ErrorType = {
  timeout: 'ECONNABORTED',
  no_network: 'ERR_NETWORK',
};
